<template>
  <div>
    <div class="clear">
      <self-back :pageHeaderList="[{ 'name': '结算单申请详情' }]" style="float:left"></self-back>
      <div style="display:inline-block;float:right;margin-top:10px">
        <!-- <el-button type='primary' size='mini' @click="print_png_DOM">导出<span style="font-size:12px">（图片格式）</span></el-button> -->
        <el-button type='primary' size='mini' @click="printDOM">导出<span style="font-size:12px">（PDF格式）</span><i
            v-show="exportFlag" class="el-icon-loading"></i></el-button>
      </div>
    </div>
    <div class="statementToast" v-loading='loading'>
      <div v-if="dataInfo.account && dataInfo.order">
        <div ref="printStatement2" id="ImageExportDom">
          <img src="@/assets/img/voided.png" v-if="dataInfo.account.is_voided == 1" class="voided" alt="">
          <div class="mainTitle">
            <h3 v-if="type == 2">MCN机构服务费结算单</h3>
            <h3 v-else>{{ dataInfo.account.party_a_name }}结算单</h3>
            <div class="bothSides">甲方：{{ dataInfo.account.party_a_name }}</div>
            <div class="bothSides">乙方：{{ dataInfo.account.name }}</div>
            <div class="bothSides statementsID" v-if="dataInfo.account.statements_id">
              序列号：{{ dataInfo.account.statements_id }}</div>
            <div class="bothSides statementsID" style="top:100px" v-if="statement_id">{{ dataInfo.account.verify_status ==
              0 ? '已保存' : dataInfo.account.verify_status == 1 ? '商务待审核' : dataInfo.account.verify_status ==
                2 ? '财务待审核' : dataInfo.account.verify_status == 3 ? '商务驳回' : dataInfo.account.verify_status ==
                  4 ? '财务审核通过' : dataInfo.account.verify_status == 5 ? '财务驳回' : '' }}</div>
            <div class="bothSides statementsID" style="top:75px"
              v-if="dataInfo && dataInfo.account && dataInfo.account.applicant_time">申请时间：{{
                dataInfo.account.applicant_time }}
            </div>
          </div>
          <game-statement v-if="type == 5" :dataInfo='dataInfo'></game-statement>
          <cpa-statement v-if="type == 4" :dataInfo="dataInfo"></cpa-statement>
          <mcn-statement v-if="type == 2" :dataInfo="dataInfo"></mcn-statement>
          <pdd-statement v-if="type == 6" :dataInfo="dataInfo"></pdd-statement>
          <div class="bothSidesBox clear">
            <div class="aParty">
              <div class="title">甲方银行账号信息如下：</div>
              <div class="infoItem">
                <label>名称：</label>
                <div class="inputDiv">{{ dataInfo.account.party_a_name }}</div>
              </div>
              <div class="infoItem">
                <label>税号：</label>
                <div class="inputDiv">{{ dataInfo.account.party_a_ein }}</div>
              </div>
              <div class="infoItem">
                <label style="vertical-align: top;">地址/电话：</label>
                <div class="inputDiv">{{ dataInfo.account.party_a_address }}</div>
              </div>
              <div class="infoItem">
                <label style="vertical-align: top;">银行/账号：</label>
                <div class="inputDiv">{{ dataInfo.account.party_a_account }}</div>
              </div>
              <div class="infoItem">
                <label style="width:100%">甲方：{{ dataInfo.account.party_a_name }}</label>
              </div>
              <div class="infoItem">
                <label>签字盖章：</label>
              </div>
              <div class="infoItem">
                <label>联系人：</label>
                <div class="inputDiv">{{ dataInfo.account.party_a_contact }}</div>
              </div>
              <div class="infoItem">
                <label>联系电话：</label>
                <div class="inputDiv">{{ dataInfo.account.party_a_phone }}</div>
              </div>
              <div class="infoItem">
                <label>日期：</label>
                <div class="inputDiv">{{ dataInfo.account.party_a_add_date }}</div>
              </div>
            </div>
            <div class="aParty">
              <div class="title">乙方银行账号信息如下：</div>
              <div class="infoItem">
                <label>账号名称：</label>
                <div class="inputDiv">{{ dataInfo.account.name }}</div>
              </div>
              <div class="infoItem">
                <label>开户银行：</label>
                <div class="inputDiv">{{ dataInfo.account.bank }}</div>
              </div>
              <div class="infoItem">
                <label>账户：</label>
                <div class="inputDiv">{{ dataInfo.account.account }}</div>
              </div>

              <div class="infoItem" style="margin-top:58px">
                <label style="width:100%">乙方：{{ dataInfo.account.name }}</label>
              </div>
              <div class="infoItem">
                <label>签字盖章：</label>
              </div>
              <div class="infoItem">
                <label>联系人：</label>
                <div class="inputDiv">{{ dataInfo.account.party_b_contact }}</div>
              </div>
              <div class="infoItem">
                <label>联系电话：</label>
                <div class="inputDiv">{{ dataInfo.account.party_b_phone }}</div>
              </div>
              <div class="infoItem">
                <label>日期：</label>
                <div class="inputDiv">{{ dataInfo.account.add_date }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="verify_opinion"
          v-if="statement_id && dataInfo.account && dataInfo.account.files && dataInfo.account.files.length > 0">
          <label style="vertical-align: top;">附件</label>
          <div v-if="dataInfo.account && dataInfo.account.files.length != 0" style="display:inline-block">
            <div v-for="(item, index) in dataInfo.account.files" :key="index">
              <div class="enclosure" @click="lookFile(item)">
                <i class="el-icon-search"></i>
                <span>{{ item && item.split('/') && item.split('/')[item.split('/').length - 1] ?
                  item.split('/')[item.split('/').length - 1] : '附件' }}</span>
              </div>
              <div class="enclosure" @click="downLoadFiles(item)">
                <i class="el-icon-download"></i>
                <span>下载附件</span>
              </div>
            </div>
          </div>
        </div>

        <!-- S 新增"经手人备注" -->
        <div class="verify_opinion no-print">
          <div class="item" style="line-height: 20px;">
            <label>经手人备注：</label>
            <span style="color:#5E5F6B;font-size:14px;">{{ dataInfo.account.handler_remark || '-' }}</span>
          </div>
        </div>
        <!-- E 新增"经手人备注" -->

        <div class="verify_opinion no-print">
          <div class="item" v-if="dataInfo.account.verify_status && dataInfo.account.verify_status != 1">
            <div style="margin:5px 0">
              <label>商务审核人：</label>
              <span style="color:#5E5F6B;font-size:14px;">{{ dataInfo.account.verify_user }}</span>
            </div>
            <div style="margin:5px 0">
              <label>商务审核时间：</label>
              <span style="color:#5E5F6B;font-size:14px;">{{ dataInfo.account.verify_time }}</span>
            </div>
            <div style="margin:5px 0">
              <label>商务审核备注：</label>
              <span style="color:#5E5F6B;font-size:14px;">{{ dataInfo.account.verify_opinion }}</span>
            </div>
          </div>
          <div class="item" v-if="dataInfo.account.verify_status == 4 || dataInfo.account.verify_status == 5">
            <div style="margin:5px 0">
              <label>财务审核人：</label>
              <span style="color:#5E5F6B;font-size:14px;">{{ dataInfo.account.confirm_verify_user }}</span>
            </div>
            <div style="margin:5px 0">
              <label>财务审核时间：</label>
              <span style="color:#5E5F6B;font-size:14px;">{{ dataInfo.account.confirm_verify_time }}</span>
            </div>
            <div style="margin:5px 0">
              <label>财务审核备注：</label>
              <span style="color:#5E5F6B;font-size:14px;">{{ dataInfo.account.confirm_verify_opinion }}</span>
            </div>
          </div>
          <!-- S 预审 -->
          <!-- 财务预审结果 -->
          <div class="item" v-if="isFinance || (userInfo.role_id == 18 && dataInfo.account.pre_audit_status)">
            <div style="margin:5px 0">
              <label>预审结果：</label>
              <span style="color:#5E5F6B;font-size:14px;">{{ dataInfo.account.pre_audit_status == 1 ? '通过' : dataInfo.account.pre_audit_status == 2 ? '驳回' : '' }}</span>
            </div>
            <div style="margin:5px 0">
              <label>预审备注：</label>
              <span style="color:#5E5F6B;font-size:14px;">{{ dataInfo.account.pre_audit_content }}</span>
            </div>
          </div>
          <!-- 财务预审 -->
          <div class="item" v-if="userInfo.role_id == 18 && dataInfo.account.verify_status == 2 && !dataInfo.account.pre_audit_status">
            <div style="margin-top:15px">
              <label>预审结果：</label>
              <el-radio-group v-model="preAudit.status">
                <el-radio :label="1">通过</el-radio>
                <el-radio :label="2">驳回</el-radio>
              </el-radio-group>
            </div>
            <div style="margin:10px 0">
              <label>预审备注：</label>
              <el-input class="textarea" type="textarea" maxlength="300" placeholder="请输入审核原因" v-model="preAudit.content"></el-input>
            </div>
          </div>
          <!-- E 预审 -->

          <div class="item" v-if="dataInfo.account.verify_status == 1 || (dataInfo.account.verify_status == 2 && isFinance)">
            <label>审核备注：</label>
            <el-input class="textarea" type="textarea" placeholder="请输入审核原因" v-model="reason">
            </el-input>
          </div>
        </div>
        <div slot="footer" style="text-align: center;margin-top:40px" class="no-print"
          v-if="dataInfo.account.is_voided != 1">
          <!-- 商务审核 -->
          <div v-if="userInfo.role_id == 15">
            <el-button type="primary" size='small' @click="editStatement(2)" v-if="dataInfo.account.verify_status == 1">审核通过</el-button>
            <el-button type="primary" size='small' @click="editStatement(3)" v-if="dataInfo.account.verify_status == 1" style="background:#d51313;border-color:#d51313">审核不通过</el-button>
          </div>
          <!-- 财务10 || 财务17(合一科技公司) || 21(新财务) -->
          <div v-if="isFinance">
            <el-button type="primary" size='small' @click="editStatement(4)" v-if="dataInfo.account.verify_status == 2">审核通过</el-button>
            <el-button type="primary" size='small' @click="editStatement(5)" v-if="dataInfo.account.verify_status == 2" style="background:#d51313;border-color:#d51313">审核不通过</el-button>
          </div>
          <!-- 财务预审 -->
          <div v-if="userInfo.role_id == 18 && dataInfo.account.verify_status == 2 && !dataInfo.account.pre_audit_status">
            <el-button type="primary" size='small' @click="preAuditSubmit">提交</el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 导出文件 -->
    <export-tem :dataInfo='dataInfo' :type='type' v-if="exportFlag" @exportSuccess='exportFlag = false;'></export-tem>
    <!-- 查看文件  -->
    <!-- <look-file v-if="lookFlag" :fileUrl = 'file_url' @close="()=>{lookFlag=false}"></look-file> -->
  </div>
</template>
<script>
// import lookFile from '@/components/assembly/lookFile'
import cpaStatement from './cpaStatement.vue';
import gameStatement from './gameStatement.vue';
import mcnStatement from './mcnStatement.vue';
import pddStatement from './pddStatement.vue'
import exportTem from '../statementTemplate/exportTem.vue'
export default {
  components: { gameStatement, cpaStatement, mcnStatement, pddStatement, exportTem },
  data () {
    return {
      loading: false,
      type: '',
      dataInfo: {},
      discountFlag: true,
      lookFlag: false,
      file_url: '',
      userInfo: {},
      reason: '',
      type: '',
      exportFlag: false,
      preAudit: {//财务预审
        status: '',
        content: ''
      },
    }
  },
  computed: {
    isFinance() { // 当前角色是否为财务 role_id 财务10 || 财务17(合一科技公司) || 21新财务)
      return [10, 17, 21].includes(Number(this.userInfo.role_id))
    },
  },
  created () {
    this.type = this.$route.params.type;
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
    this.statement_id = this.$route.params.id;
    this.statementsDetail()
  },
  methods: {
    /**提交预审 */
    preAuditSubmit(){
      if (this.preAudit.status == '' || !this.preAudit.status) {
        this.$message.warning('请选择预审结果')
        return
      }
      if (this.preAudit.status == 2 && (this.preAudit.content == '' || !this.preAudit.content)) {
        this.$message.warning('请输入审核意见')
        return
      }
      this.$loading(this.$loadingConfig);
      this.$axios.post(this.URL.BASEURL + this.URL.preAuditRecordSave,{
          type: 2,
          data_id_list: [ this.statement_id ],
          status: this.preAudit.status,
          content: this.preAudit.content,
      }).then((res) => {
          var res=res.data;
          this.$loading(this.$loadingConfig).close();
          if(res&& res.errno == 0){
            this.$router.push({ path: '/statementExamine?type=' + this.type })
          }else {
            this.$message({
                message: res.err,
                type: 'warning'
            })
          }
      }).catch(()=>{
        this.$loading(this.$loadingConfig).close();
      })
    },
    downLoadFiles (data) {//下载
      var url = data.replace("http://", window.location.protocol + '//');
      var doc_name = (url.split('/'))[url.split('/').length - 1]
      this.ajax(url, (xhr) => {
        this.downloadFile(xhr.response, doc_name)
      }, {
        responseType: 'blob'
      })
    },
    ajax (url, callback, options) {
      window.URL = window.URL || window.webkitURL
      var xhr = new XMLHttpRequest()
      xhr.open('get', url, true)
      if (options.responseType) {
        xhr.responseType = options.responseType
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          callback(xhr)
        }
      }
      xhr.send()
    },
    downloadFile (content, filename) {
      var a = document.createElement('a')
      var blob = new Blob([content])
      var url = window.URL.createObjectURL(blob)
      a.href = url
      a.download = filename
      a.click()
      window.URL.revokeObjectURL(url)
    },
    lookFile (data) {//查看文件
      this.file_url = data;
      let routeData = this.$router.resolve({
        path: '/lookFile?url=' + this.file_url,
      })
      this.$winopen(routeData.href)
    },
    print_png_DOM () {
      this.getPdf({ title: this.type == 2 ? 'MCN机构服务费结算单' : this.dataInfo.account.party_a_name + '结算单', noScrollBar: false, invoice: true })
    },
    printDOM () {
      this.$loading(this.$loadingConfig);
      this.exportFlag = true;
    },
    statementsDetail () {
      this.loading = true;
      this.$axios.get(this.URL.BASEURL + this.URL.statementsDetail, {
        params: {
          id: this.statement_id
        }
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.dataInfo = res.rst;
          this.preAudit.status = res.rst.account.pre_audit_status;
          this.preAudit.content = res.rst.account.pre_audit_content;
          if (this.userInfo.role_id == 15) {//商务
            this.reason = this.dataInfo.account.verify_opinion
          } else if (this.isFinance) {//财务
            this.reason = this.dataInfo.account.confirm_verify_opinion
          }
          this.discountFlag = this.dataInfo.account.is_discount ? true : false
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    editStatement (status) {//提交
      if ((status == 3 || status == 5) && (!this.reason || this.reason == '')) {
        this.$message({
          message: '请输入审核原因',
          type: 'warning'
        })
        return
      }
      this.loading = true;
      this.$axios.post(this.URL.BASEURL + this.URL.statementsVerify, {
        id: this.statement_id,
        status: status,
        opinion: this.reason
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.$router.push({ path: '/statementExamine?type=' + this.type })
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
  }
}
</script>
<style lang="scss" scoped>
@import "../statementTemplate/statementDetail.scss";
</style>
<style lang="scss">
.statementToast {
  .el-form-item__content {
    font-size: 12px !important;
  }

  .el-form-item--mini.el-form-item {
    margin-bottom: 0 !important;
  }

  .table .el-input__inner {
    padding: 0 !important;
    text-align: center !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newBilling/examine/examineStatement.vue